import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiResponseSimple } from 'src/app/shared/models/api-response-simple/ApiResponseSimple';
import { catchError, switchMap, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { EnvironmentResolveService } from '../environment-resolve/environment-resolve.service';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {
  constructor(
    private http: HttpClient,
    private erService: EnvironmentResolveService) {}

  public requestLink(captcha: string, email: string): Observable<any> {
    const body = {
      type: 'link',
      captcha,
      email
    };

    return this.http.post(this.erService.environmentERS.apiUrlForgotPassword, body).pipe(
      map((response: ApiResponseSimple) => {
        return response;
      }),
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }

  public requestReset(captcha: string, token: string, password: string): Observable<any> {
    const body = {
      type: 'reset',
      captcha,
      token,
      password
    };

    return this.http.post(this.erService.environmentERS.apiUrlForgotPassword, body).pipe(
      map((response: ApiResponseSimple) => {
        return response;
      }),
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
}
